import type React from 'react';
import type { PagesLayoutAnalyticsData } from '@/layouts/PagesLayout';
import { ActOnSettlementPage } from './ActOnSettlementPage.tsx';

interface ActOnSettlementContainerProps {
  analytics: PagesLayoutAnalyticsData;
}

export function ActOnSettlementPageContainer({ analytics }: ActOnSettlementContainerProps) {
  const handleGoBack = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    window.history.back();
  };

  return <ActOnSettlementPage handleGoBack={handleGoBack} analytics={analytics} />;
}
